import DuplicateIcon from '@mui/icons-material/LibraryAdd'
import { darken } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { MotionFab } from '@components'
import { colors } from '@global/constants'

interface Props {
  numSelectedRows: number
  duplicateRows: () => void
}

const useStyles = makeStyles(() => ({
  custom: {
    '&&': {
      backgroundColor: colors.blue.main,
      '&:hover': {
        backgroundColor: darken(colors.blue.main, 0.3),
      },
    },
  },
}))

/**
 * The duplicate rows button in the read grid header
 *
 * @param props React props
 * @param {number} props.numSelectedRows The number of rows selected for removal
 * @param {func} props.duplicateRows Function to remove the rows from the dataset
 * @returns
 */
export const DuplicateRows = ({ numSelectedRows, duplicateRows }: Props) => {
  const classes = useStyles()
  const disabled = numSelectedRows === 0
  const title =
    numSelectedRows === 1 ? `Duplicate ${numSelectedRows} row` : `Duplicate ${numSelectedRows} rows`

  return (
    <MotionFab
      tooltipTitle={title}
      size="medium"
      disabled={disabled}
      className={classes.custom}
      onClick={duplicateRows}
      data-testid="duplicate-rows"
    >
      <DuplicateIcon />
    </MotionFab>
  )
}
